export default "__VITE_ASSET__DT4HsRIK__"